/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileManagerDirectoryContent } from '../../models/file-manager-directory-content';

export interface ApiFileManagerDownloadPost$Plain$Params {
      body?: FileManagerDirectoryContent
}

export function apiFileManagerDownloadPost$Plain(http: HttpClient, rootUrl: string, params?: ApiFileManagerDownloadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiFileManagerDownloadPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiFileManagerDownloadPost$Plain.PATH = '/api/FileManager/Download';
